export default function rankLabel(rank, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  attrs.style = attrs.style || {};
  attrs.className = 'rankLabel ' + (attrs.className || '');
  const color = rank.color();
  attrs.style.backgroundColor = attrs.style.color = color;
  attrs.className += ' colored';
  return m('span', attrs, m("span", {
    className: "rankLabel-text"
  }, rank.name()));
}
flarum.reg.add('fof-gamification', 'common/helpers/rankLabel', rankLabel);